import * as React from "react";
export var formatDateExpiration = function formatDateExpiration(date_expiration) {
  return date_expiration.replace(/^([1-9]\/|[2-9])$/g, "0$1/" // To handle 3/ > 03/
  ).replace(/^(0[1-9]{1}|1[0-2]{1})$/g, "$1/" // 11 > 11/
  ).replace(/^([0-1]{1})([3-9]{1})$/g, "0$1/$2" // 13 > 01/3
  ).replace(/^(\d)\/(\d\d)$/g, "0$1/$2" // To handle 1/11 > 01/11
  ).replace(/^(0?[1-9]{1}|1[0-2]{1})([0-9]{2})$/g, "$1/$2" // 141 > 01/41
  ).replace(/^([0]{1,})\/|[0]{1,}$/g, "0" // To handle 0/ > 0 and 00 > 0
  ).replace(/[^\d\/]|^[\/]{0,}$/g, "" // To allow only numbers and /
  ).replace(/\/\//g, "/" // Prevent entering more than 1 /
  );
};

var CardDate = function CardDate(props) {
  var onChange = props.onChange,
      _props$value = props.value,
      value = _props$value === void 0 ? "" : _props$value;

  var handleInput = function handleInput(event) {
    event.preventDefault();
    var dateExpirationFormatted = formatDateExpiration(event.target.value);
    event.target.value = dateExpirationFormatted;
    onChange && onChange(dateExpirationFormatted);
  };

  return /*#__PURE__*/React.createElement("input", {
    value: value || "",
    className: "form-control",
    placeholder: "MM/YY",
    maxLength: 5,
    onChange: handleInput
  });
};

export default CardDate;